import {Skeleton, Stack} from "@mui/material";
import {useUser} from "../store/user-context";
import LinearProgressWIthLabel from "./_atoms/LinearProgressWIthLabel";
import Typography from "@mui/material/Typography";
import {clamp, humanizedDuration} from "../utils/helpers";
import Button from "@mui/material/Button";
import { usePackageModal } from "../store/modal-context";

const UsageProgress = () => {
    const userCtx = useUser();
    const packageModalCtx = usePackageModal();

    let percentageValue = 0;
    if (userCtx.totalSeconds > 0) {
        percentageValue = clamp(userCtx.usedSeconds * 100 / userCtx.totalSeconds, 0, 100);
    }

    const addCreditsBtnClickHandler = () => {
        packageModalCtx.openModal();
    }

    return <Stack border={1} borderRadius={2} borderColor="#ccc" px={2} py={1} flexDirection='column'>
        {(userCtx.totalSeconds > 0) && <>
            <LinearProgressWIthLabel value={percentageValue} />
            <Typography variant={'body1'}>
                <strong>{ humanizedDuration(userCtx.usedSeconds) }</strong> di <strong>{ humanizedDuration(userCtx.totalSeconds) }</strong> utilizzati;
            </Typography>
            <Button size='small' onClick={addCreditsBtnClickHandler}>Aggiungi ore extra</Button>
        </>}
        {(userCtx.totalSeconds === 0) && <>
            <LinearProgressWIthLabel value={percentageValue} />
            <Typography variant={'body1'}>
                <Skeleton />
            </Typography>
            <Button>
                <Skeleton />
            </Button>
        </>}
    </Stack>
};

export default UsageProgress;
